"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_router_dom_1 = require("react-router-dom");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Context_1 = require("../Context");
require("../Styles/Header.css");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleNavbar = _this.toggleNavbar.bind(_this);
        _this.state = {
            collapsed: true
        };
        return _this;
    }
    Header.prototype.toggleNavbar = function () {
        this.setState({
            collapsed: !this.state.collapsed
        });
    };
    Header.prototype.render = function () {
        var _this = this;
        return (React.createElement(Context_1.GlobalConsumer, null, function (context) { return context && (React.createElement(Context_1.AuthConsumer, null, function (auth) { return auth && (React.createElement(reactstrap_1.Navbar, { className: "border-bottom mb-3", color: "primary", expand: "sm", light: true },
            React.createElement(reactstrap_1.Container, null,
                React.createElement(reactstrap_1.NavbarToggler, { onClick: _this.toggleNavbar, className: "mr-2 navbar-dark" }),
                React.createElement(reactstrap_1.Collapse, { className: "d-sm-inline-flex flex-sm-row-reverse", isOpen: !_this.state.collapsed, navbar: true },
                    React.createElement(reactstrap_1.Nav, { navbar: true },
                        React.createElement(reactstrap_1.NavItem, { className: "text-light my-2 " }, _this.props.resources.Welcome),
                        React.createElement(reactstrap_1.UncontrolledDropdown, { nav: true, inNavbar: true },
                            React.createElement(reactstrap_1.DropdownToggle, { className: "text-light", nav: true },
                                React.createElement("span", { className: "mr-1" }, auth.getUser().name),
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "nav-item-user-icon", icon: free_solid_svg_icons_1.faUserCircle })),
                            React.createElement(reactstrap_1.DropdownMenu, null,
                                React.createElement(reactstrap_1.DropdownItem, { tag: react_router_dom_1.Link, to: "/", onClick: auth.editProfile }, _this.props.resources.EditProfile),
                                React.createElement(reactstrap_1.DropdownItem, { tag: react_router_dom_1.Link, to: "/CalibrateScanner" }, _this.props.resources.CalibrateScanner),
                                context.userInfo.UserRole.match(/Administrator/g) &&
                                    React.createElement(reactstrap_1.DropdownItem, { tag: react_router_dom_1.Link, to: "/Settings" }, _this.props.resources.AdminSettings),
                                React.createElement(reactstrap_1.DropdownItem, { tag: react_router_dom_1.Link, to: "/", onClick: auth.passwordReset }, _this.props.resources.ResetPassword),
                                React.createElement(reactstrap_1.DropdownItem, { divider: true }),
                                React.createElement(reactstrap_1.DropdownItem, { tag: react_router_dom_1.Link, to: "/" }, _this.props.resources.LogOut))),
                        React.createElement(reactstrap_1.NavItem, { className: "text-light my-2" },
                            React.createElement("small", null,
                                _this.props.resources.Not,
                                " ",
                                auth.getUser().name,
                                "? ",
                                _this.props.resources.Please)),
                        React.createElement(reactstrap_1.NavLink, { className: "text-light pl-1 pointer", onClick: function () { return auth.logout(); } },
                            React.createElement("small", null, _this.props.resources.LogOut))))))); })); }));
    };
    return Header;
}(React.Component));
exports.Header = Header;
//# sourceMappingURL=Header.js.map